import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import BriaSlider, { IBriaSliderProps } from "../../../../../../../components/common/BriaSlider/BriaSlider";
import { FIBO_DEFAULT_STEPS } from "../../../../../../../constants/FiboConstants";
import { IMAGE_REFERENCE_CONFIGS } from "../../../../../../../constants/TextToImageConstants";
import { useAppStore } from "../../../../../../../hooks/useStores";
import { isFiboApp } from "../../../../../../../utils";

const TextToImageStepsSlider = ({ ...props }: IBriaSliderProps) => {
	const { textToImageStore } = useAppStore();
	const { handleConfigChange } = textToImageStore;

	const {
		min,
		max,
		default: defaultSteps,
	} = IMAGE_REFERENCE_CONFIGS.steps[
		textToImageStore.config?.model_id === "fibo"
			? "fibo"
			: textToImageStore.config?.model_id === "fibo_lite"
				? "fibo_lite"
				: textToImageStore.config?.fast
					? "fast"
					: "not_fast"
	];

	useEffect(() => {
		const currentSteps = textToImageStore.config?.steps_num;
		const isFiboLite = textToImageStore.config?.model_id === "fibo_lite";
		const targetDefaultSteps = isFiboLite ? defaultSteps : isFiboApp() ? FIBO_DEFAULT_STEPS : defaultSteps;

		const shouldUpdate =
			typeof currentSteps !== "number" ||
			currentSteps <= min ||
			currentSteps >= max ||
			currentSteps === targetDefaultSteps;

		if (shouldUpdate) {
			handleConfigChange("steps_num", targetDefaultSteps);
		}
	}, [textToImageStore.config?.fast]);

	return (
		<BriaSlider
			value={textToImageStore.config?.steps_num}
			onChange={(_, value) => handleConfigChange("steps_num", value as number)}
			step={1}
			min={min}
			max={max}
			valueLabelDisplay="auto"
			marks={[0, 0.25, 0.5, 0.75, 1].map((f) => {
				const value = min + Math.round((max - min) * f);
				return { value, label: String(value) };
			})}
			{...props}
		/>
	);
};

export default observer(TextToImageStepsSlider);
